/**
 * Human-readable text for an unknown thrown value, for banners and toasts.
 *
 * ApiError (lib/api.ts) already carries the API's own user-facing message and
 * extends Error, so it needs no special case. `fallback` covers the
 * thrown-non-Error case — pass a caller-specific one when the message is going
 * to be embedded in a sentence.
 */
export function errorText(error: unknown, fallback = 'Something went wrong'): string {
  if (error instanceof Error && error.message) return error.message;
  return fallback;
}
